module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-600.5cf8dfe8.ttf";